<template>
  <div class="cover-image-container">
    <a
      :href="homepage_url"
      class="cover-image"
      :title="heading"
      target="_blank"
    >
      <img :src="cover_image_url" :alt="heading" />
    </a>
    <img
      class="institution-logo"
      :src="logo_attachment_url"
      alt=""
      width="80"
      height="80"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("siteBrand", [
      "cover_image_url",
      "logo_attachment_url",
      "homepage_url",
      "heading",
    ]),
  },
};
</script>

<style scoped lang="scss">
.cover-image-container {
  position: relative;
  margin-bottom: rem(40);
  .cover-image {
    img {
      border-radius: rem(12);
      width: 100%;
      height: rem(150);
      object-fit: cover;
    }
  }
  .institution-logo {
    border-radius: rem(12);
    width: rem(80);
    height: rem(80);
    position: absolute;
    left: rem(20);
    bottom: rem(-40);
  }
}
</style>
